var map = {
	"./Admin-Controls.ts": 8632,
	"./Getting-Started.ts": 7635,
	"./Highlight-Buffs.js": 6822,
	"./Map-Export-Filter.js": 6581,
	"./Metrics.ts": 5892,
	"./Performance-Optimiser.js": 9089,
	"./Remote-Explorer.ts": 3569,
	"./Repeat-Attack.js": 6362,
	"./Upgrade-Manager.js": 1447,
	"./Voyage-Time.js": 7986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7480;